/* global schedulesImportUrl canScheduleCreate canScheduleUpdate fetchScheduleTypesUrl fetchSchedulesUrl exportSchedulesUrl upsertScheduleTypesUrl deleteScheduleTypeUrl bulkDeleteUrl fetchVenuesUrl updateScheduleBaseUrl eventStartDate eventEndDate sessionsEventId sessionsBudgetId */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SessionsTable from './SessionsTable';
import SessionTypesTable from './SessionTypesTable';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

import { BulkDeleteProvider } from 'Context/BulkDeleteContext';
import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

export default function SessionsTab(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [scheduleTypes, setScheduleTypes] = useState([]);

    useEffect(() => {
        fetchScheduleTypes();
    }, []);

    const fetchScheduleTypes = () => {
        setIsLoading(true);

        axios
            .get(props.fetchScheduleTypesUrl)
            .then(({ data }) => {
                setScheduleTypes(data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="tw-space-y-4 tw-pb-12">
            <div>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <SessionTypesTable
                        scheduleTypes={scheduleTypes}
                        upsertScheduleTypesUrl={props.upsertScheduleTypesUrl}
                        deleteScheduleTypeUrl={props.deleteScheduleTypeUrl}
                        onRefetch={fetchScheduleTypes}
                    />
                )}
            </div>

            <div>
                <ConfirmationModalProvider>
                    <BulkDeleteProvider>
                        <SessionsTable
                            fetchSchedulesUrl={props.fetchSchedulesUrl}
                            exportSchedulesUrl={props.exportSchedulesUrl}
                            canScheduleCreate={canScheduleCreate}
                            canScheduleUpdate={canScheduleUpdate}
                            fetchVenuesUrl={props.fetchVenuesUrl}
                            updateScheduleBaseUrl={props.updateScheduleBaseUrl}
                            scheduleTypes={scheduleTypes}
                            bulkDeleteUrl={bulkDeleteUrl}
                            schedulesImportUrl={schedulesImportUrl}
                            eventStartDate={props.eventStartDate}
                            eventEndDate={props.eventEndDate}
                            eventId={props.eventId}
                            budgetId={props.budgetId}
                        />
                    </BulkDeleteProvider>
                </ConfirmationModalProvider>
            </div>
        </div>
    );
}

if (document.getElementById('SessionsTab')) {
    var rootEl = document.getElementById('SessionsTab');
    ReactDOM.render(
        <App>
            <SessionsTab
                fetchScheduleTypesUrl={fetchScheduleTypesUrl}
                upsertScheduleTypesUrl={upsertScheduleTypesUrl}
                deleteScheduleTypeUrl={deleteScheduleTypeUrl}
                fetchSchedulesUrl={fetchSchedulesUrl}
                exportSchedulesUrl={exportSchedulesUrl}
                fetchVenuesUrl={fetchVenuesUrl}
                updateScheduleBaseUrl={updateScheduleBaseUrl}
                eventStartDate={eventStartDate}
                eventEndDate={eventEndDate}
                eventId={typeof sessionsEventId !== 'undefined' ? sessionsEventId : null}
                budgetId={typeof sessionsBudgetId !== 'undefined' ? sessionsBudgetId : null}
            />
        </App>,
        rootEl,
    );
}
